module.exports = {
  WEB_BUILDER_PATH: '/developer/builder',
  STORAGE_UNAVAILABLE_URL: '/app/login/cookies-disabled',
};
